<template>
  <div id="contact-index">
    <header-section :subnav_show="false" :change_color="true"></header-section>
    <!-- ======= Hero Section ======= -->
    <div id="hero-contact" data-aos="zoom-out" data-aos-delay="100"></div>
    <div class="contact" data-aos="fade-up" data-aos-delay="100">
      <div class="nap-container">
        <div class="section-title mt-5">
          <h2>联系我们</h2>
          <p>CONTACT</p>
        </div>
        <div class="contact_title_div contact_title_div_m">联系方式</div>
        <el-row class="margin-l-r-12">
          <el-col :span="16" style="padding-left: 12px; padding-right: 12px">
            <div class="contact_text1">
              为您提供专业问题解答、服务咨询等一对一服务，工作时间：周一至周六，8:30至17:30（节假日除外）
            </div>
            <el-row class="contact_us_div row">
              <el-col :span="12">
                <div style="display: flex">
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAflBMVEUAAAB0gKd0gaeIorR1gad4h6qElKx8irB1gaZ0gKd1gKd1gKd3gah4hap1gad0gqd0gKd3gqh5hqh1gad1gqh3g6l6jLB0gad2gKd1gqd1gah3hKh0gKd1gKd1gad0gad0gad1gad2gqd2g6h1gKd1gqh1gad0gad1gad0gKaw8YKWAAAAKXRSTlMA9PkGgBgKEu7d47BIJpVb2UAet2IxDuaOemgs6tHDvqGaVjnKT3CGqiXLAOAAAAKUSURBVEjHhVXnmqowECWh946gICpX9/L+L7jMJGQ04VvPH9KmnGlYAu3/iE+DbRF4ENb907MO4d9XxNzRmThhceOb7/NglbhqAigzaGbseCUMJEA4nT8EhDvTo523D2/3Yy8t8z6UIv8qet/CQQA63BEEgTjh4ozCyKKOsm1bCAVPuPrRCHoOg2Oe7wfTtnvK9Q2uSkuDK0juEhCh3cMu2jahiC0r5iyR/jloQ3rFt7Xyu4SbnqLEMhc3DwY8KmWBctODqvQtrMyxUQJjhU+KbXUhirC9kQA8c5VXmI+a+AASYCHykGQRSkSoLwanPCl6JwHkpGqhOaEE2HCZLIQSVSoskEbadjF6ZUvNzN9Ms/fY++BFLdaU2NUBHyHnDWYLaVLqOMVgd5650kQsfeIVUdaLowMeGdQVSAK9QtH2Qoy2hgYeAotQVlGuklUZtYQAXonMar/nblaVGONK551JzbXKewOrswiJAjGbKQMy2wFWwEyFTEihZeCrclSx3ZgbAaFE6yFgLb9cHL1A8Qs7lsFta33DFQeA6tMx/SZQBUDIV9ZOl28Sz1UV0Q/OEcXDb2keGkXWyyXNtKbYfI2PONlX7Clq+rWurHRaBe7ahFURXR9CL8d+vrF1x/gwJVpGOVgiGsaj+MauIZFwkvBj+bz3rSTEZdCYc/99KOabkWlwkZ/DhRGDyZniA3OD4ple8SZ0jyUy22T4YmKW6Xig8Stp0oyYPMoAS6M8yFSNfWFqCpG6Y7pVYZmb8GskUiz6xSI7zoSzIjL/06WJ+ldHchJZ+3kXuYlZeYxO/uqDXrUSDfxjlMX+sx8W1+4ud1xbf8B+BasGmPt/oRvGj/fsYn2Dl8/0PoT331Gdb8XIWRQ3IpO/Cbp0Ux2YvvUAAAAASUVORK5CYII="
                    class="contact_icon1" />
                  <label class="contact_text2">服务热线</label>
                </div>
                <div class="contact_text3 contact_us_m">400-666-1916</div>
              </el-col>
              <el-col :span="12">
                <div style="display: flex">
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAALVBMVEUAAAB2g6h1gaZ1gKeIkLJ6i6+MnLx8ibB0gaZ2ia13iKl6iat1gad7hKp0gKZ4ofn9AAAADnRSTlMAPcC5Cg4GEukcGRamG6TIkbYAAADSSURBVDjLvdMxCsIwFMbxJ6ggIhRv4EXEoTq7BNdOmd0yeAJBpKNurnZythdw8gCuLg6SMxheoR8xeWiXfkvh/xsKgUdtbHCzke1yOtjotnSPw5v2cXiRtcdHUZSlMUYplabpQutsZK0DCjeUoCdBV4I+QxJCh+GZBH3KAEF3MGYJ+oQgXx3id0jYIei++N1aCDqehKXqgFqqDoBwB0C4A2rhDsgI+w9mjWHpvt5+wroxXKSfnxpDTqS1dgcwV2plzKa8FmcH0uGIpyYep3zOLewD39Ke67deflkAAAAASUVORK5CYII="
                    class="contact_icon1" />
                  <label class="contact_text2">联系邮箱</label>
                </div>
                <div class="contact_text3">webmaster@createc.cn</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="8" class="padding-l-r-12">
            <div style="padding-left: 40px">
              <div class="contact_text1 hidden-sm-and-down">
                提交您的需求信息，我们将尽快与您联系
              </div>
              <div style="display: flex; margin-top: 36px">
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAQlBMVEUAAAB2iat1gad0gaZ1gaeAlq2Gn792g6d0gKd7h6t+ja90gKd1gaZ0gKd1gad0gad1gKZ1gKd5hqp0gaZ3gqZ0gKaL5IklAAAAFXRSTlMAG23mpgsGS+0VEPPy2dW2m/kqiitG7W/hAAABGUlEQVRIx+WW3Q6DIAxGWxTc/EU33v9VZ5eFhkZo6u2+C5Mm54jESgXgoNuWKYlMy+YQroIxVRMvlGFOjcyD5F1S4sT9E2V1hwcRf7g1UYo1kJ5nd1CJ2+mpEDiRb3GZgYzINRL/qsC8RSzKNUAra7HvjavWEluulrN6t4XjRJZcUT+EtuCpS3JFOwIlzJgF7Dsquh4rqGDwkX55VAzB9Cmnr/Al03HRVfiSoSuOHhsbLxm6BICnJhBzX/AAoyYQk4URwGsCMVl4AgRNIOa+gH5ERWDG+uLMrWFuPmt7i49Dzx8LE7VvVssIlI/KwyLwYawLfNxbBOSpp4ZH1j4YBJy/QyvopBy7b83RB3t9jdkoAEaLwL8/mvAB4AE5QtibMdoAAAAASUVORK5CYII="
                  class="contact_icon1" />
                <label class="contact_text2">服务咨询</label>
              </div>
              <button
                type="button"
                class="el-button el-button--primary"
                style="margin-top: 20px">
                <!---->
                <!---->
                <span>立即咨询</span>
              </button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="nap-container">
        <div class="contact_title_div contact_title_div_m">区域服务</div>
        <el-row :gutter="15" class="margin-l-r-12">
          <el-col :span="8" class="padding-l-r-12">
            <div class="contact_plat_div">
              <div class="contact_plat_text1">总公司</div>
              <div class="contact_plat_text2">曹经理</div>
              <div class="contact_plat_text3">
                电话：0311-82220136 13231118631
              </div>
            </div>
          </el-col>
          <el-col :span="8" class="padding-l-r-12">
            <div class="contact_plat_div">
              <div class="contact_plat_text1">上海子公司</div>
              <div class="contact_plat_text2">赵经理</div>
              <div class="contact_plat_text3">电话：18533119330</div>
            </div>
          </el-col>
          <el-col :span="8" class="padding-l-r-12">
            <div class="contact_plat_div">
              <div class="contact_plat_text1">广东子公司</div>
              <div class="contact_plat_text2">霍经理</div>
              <div class="contact_plat_text3">电话：18633081597</div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="15" class="margin-l-r-12">
          <el-col :span="8" class="padding-l-r-12">
            <div class="contact_plat_div">
              <div class="contact_plat_text1">山东子公司</div>
              <div class="contact_plat_text2">邓经理</div>
              <div class="contact_plat_text3">电话：18633081595</div>
            </div>
          </el-col>
          <el-col :span="8" class="padding-l-r-12">
            <div class="contact_plat_div">
              <div class="contact_plat_text1">四川子公司</div>
              <div class="contact_plat_text2">杨经理</div>
              <div class="contact_plat_text3">电话：18533113657</div>
            </div>
          </el-col>
          <el-col :span="8" class="padding-l-r-12">
            <div class="contact_plat_div">
              <div class="contact_plat_text1">北京子公司</div>
              <div class="contact_plat_text2">蔡经理</div>
              <div class="contact_plat_text3">电话：18533113682</div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="15" class="margin-l-r-12">
          <el-col :span="8" class="padding-l-r-12">
            <div class="contact_plat_div">
              <div class="contact_plat_text1">宜兴子公司</div>
              <div class="contact_plat_text2">冉经理</div>
              <div class="contact_plat_text3">电话：18003119783</div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="nap-container">
        <div class="contact_title_div contact_title_div_m">工业过程仪表</div>
        <div class="contact_sur">
          <el-row class="row">
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">总部</div>
                      <div class="contact_sur_contactor">联系人：曹经理</div>
                      <div class="contact_sur_phonenumber">
                        电话：18603271822
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">福建</div>
                      <div class="contact_sur_contactor">联系人：李锦澄</div>
                      <div class="contact_sur_phonenumber">
                        电话：18533113702
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">上海</div>
                      <div class="contact_sur_contactor">联系人：王冬艳</div>
                      <div class="contact_sur_phonenumber">
                        电话：18633081593
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row class="row">
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">浙江</div>
                      <div class="contact_sur_contactor">联系人：李亚红</div>
                      <div class="contact_sur_phonenumber">
                        电话：18603271855
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">广东省</div>
                      <div class="contact_sur_contactor">联系人：霍叶梅</div>
                      <div class="contact_sur_phonenumber">
                        电话：18633081597
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">北京、天津</div>
                      <div class="contact_sur_contactor">联系人：韩毅</div>
                      <div class="contact_sur_phonenumber">
                        电话：18633081598
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row class="row">
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div>
                      <div class="contact_sur_addr">山东</div>
                      <div class="contact_sur_contactor">联系人：邓玉琼</div>
                      <div class="contact_sur_phonenumber">
                        电话：18633081595
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div>
                      <div class="contact_sur_addr">安徽、河南</div>
                      <div class="contact_sur_contactor">联系人：程宇</div>
                      <div class="contact_sur_phonenumber">
                        电话：18003119730
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">东三省、西北</div>
                      <div class="contact_sur_contactor">联系人：牛丽娜</div>
                      <div class="contact_sur_phonenumber">
                        电话：18533113612
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">四川、重庆、云南、贵州</div>
                      <div class="contact_sur_contactor">联系人：于江磊</div>
                      <div class="contact_sur_phonenumber">
                        电话：18533119670
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
             <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">湖南、湖北、深圳</div>
                      <div class="contact_sur_contactor">联系人：陈俊钰</div>
                      <div class="contact_sur_phonenumber">
                        电话：18633081596
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="nap-container">
        <div class="contact_title_div contact_title_div_m">
          环保水质分析仪器
        </div>
        <div class="contact_sur">
          <el-row class="row">
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">总部</div>
                      <div class="contact_sur_contactor">联系人：张经理</div>
                      <div class="contact_sur_phonenumber">
                        电话：0311-82220136 18533113665
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">江苏</div>
                      <div class="contact_sur_contactor">联系人：冉经理</div>
                      <div class="contact_sur_phonenumber">
                        电话：18003119783
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">上海、浙江</div>
                      <div class="contact_sur_contactor">联系人：王经理</div>
                      <div class="contact_sur_phonenumber">
                        电话：18633081593
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row class="row">
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">广东、海南、福建</div>
                      <div class="contact_sur_contactor">联系人：付经理</div>
                      <div class="contact_sur_phonenumber">
                        电话：18631158227
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">北京、天津</div>
                      <div class="contact_sur_contactor">联系人：蔡经理</div>
                      <div class="contact_sur_phonenumber">
                        电话：18533113682
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">广西、江西</div>
                      <div class="contact_sur_contactor">联系人：付经理</div>
                      <div class="contact_sur_phonenumber">
                        电话：18631158227
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row class="row">
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">河北、河南</div>
                      <div class="contact_sur_contactor">联系人：季经理</div>
                      <div class="contact_sur_phonenumber">
                        电话：18633081776
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">安徽、山东</div>
                      <div class="contact_sur_contactor">联系人：王经理</div>
                      <div class="contact_sur_phonenumber">
                        电话：18603271877
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">湖南、湖北</div>
                      <div class="contact_sur_contactor">联系人：付经理</div>
                      <div class="contact_sur_phonenumber">
                        电话：18631158227
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row class="row">
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">四川、贵州、重庆、云南</div>
                      <div class="contact_sur_contactor">联系人：杨经理</div>
                      <div class="contact_sur_phonenumber">
                        电话：18533113657
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">
                        黑龙江、吉林、辽宁、青海
                      </div>
                      <div class="contact_sur_contactor">联系人：潘经理</div>
                      <div class="contact_sur_phonenumber">
                        电话：18533119335
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="contact_sur_bg">
                <div class="contact_sur_content">
                  <div class="contact_sur_div">
                    <div style="flex-shrink: 0">
                      <div class="contact_sur_addr">
                        陕西、宁夏、山西、甘肃、内蒙古
                      </div>
                      <div class="contact_sur_contactor">联系人：王经理</div>
                      <div class="contact_sur_phonenumber">
                        电话：18003119755
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="nap-container">
        <div class="contact_title_div contact_title_div_m">售后服务</div>
        <el-row class="contact_sur row" style="padding-bottom: 40px">
          <el-col :span="12">
            <div class="contact_sur_bg">
              <div class="contact_sur_content">
                <div class="contact_sur_title" style="margin-bottom: 20px">
                  技术咨询
                </div>
                <div
                  style="
                    font-weight: bold;
                    color: #000;
                    margin-top: 18px;
                    margin-bottom: 7px;
                  "
                  class="contact_sur_contact">
                  北区：京津冀、东三省、山东、山西
                </div>
                <div class="contact_sur_contact" style="color: #222">
                  路向阳 18503200650
                </div>
                <div
                  style="
                    font-weight: bold;
                    color: #000;
                    margin-top: 18px;
                    margin-bottom: 7px;
                  "
                  class="contact_sur_contact mt-3">
                  东区：江苏、上海、安徽、浙江、江西、河南、福建
                </div>
                <div class="contact_sur_contact" style="color: #222">
                  殷玉帅 18003116922
                </div>
                <div
                  style="
                    font-weight: bold;
                    color: #000;
                    margin-top: 18px;
                    margin-bottom: 7px;
                  "
                  class="contact_sur_contact mt-3">
                  西区：陕西、甘肃、宁夏、新疆、西藏、四川、云南、 内蒙古、青海
                </div>
                <div class="contact_sur_contact" style="color: #222">
                  潘 明 17603255611 / 陈田田 17703115917
                </div>
                <div
                  style="
                    font-weight: bold;
                    color: #000;
                    margin-top: 18px;
                    margin-bottom: 7px;
                  "
                  class="contact_sur_contact mt-3">
                  南区：湖南、湖北、广东、广西、贵州、重庆、海南、
                  台湾、香港、澳门
                </div>
                <div class="contact_sur_contact" style="color: #222">
                  闫立平 18533113670
                </div>
              </div>
              <div class="contact_sur_line" style="height: 310px"></div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="contact_sur_bg contact_sur_bg_m">
              <div class="contact_sur_content">
                <div class="contact_sur_title" style="margin-bottom: 20px">
                  售后技术支持
                </div>
                <div class="contact_sur_contact" style="color: #222">
                  来宇博 18503200653
                </div>
                <div
                  class="contact_sur_title mt-3"
                  style="margin-bottom: 20px; margin-top: 30px">
                  维修服务
                </div>
                <div class="contact_sur_contact" style="color: #222">
                  联系电话 13231118089
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="nap-container">
        <div class="contact_title_div contact_title_div_m">建议与反馈</div>
        <el-row>
          <el-col :span="12" class="padding-l-r-12">
            <img src="@/static/img/contact/feedback.png" class="contact_img1" />
            <div class="contact_sug_div">
              <div class="contact_text4 contact_text4_m">
                专注产品质量与用户体验，科瑞达用心聆听每一个声音
              </div>
              <button type="button" class="el-button el-button--primary">
                <!---->
                <!---->
                <span>提建议</span>
              </button>
            </div>
          </el-col>
          <el-col :span="12" class="padding-l-r-12">
            <div style="padding-left: 40px">
              <div style="display: flex; margin-top: 10px">
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAXVBMVEUAAAB0gaePlLh1gad1gad0gad0gKd0gad0gad1gad0gad2gqh2g6h3g6d3hKp5hql9iax3iKp0gKZ1gad1gqh0gKd1g6l3gah1gad2gaZ1gqh2gad2gqh0gKZ0gKb/qzJFAAAAHnRSTlMA9gfx6uLZz7aZiFc8MSYdFQ/EqGepSknCeXh3Zqcu8RvzAAAA/0lEQVRIx5XU6Q6CQBAD4LJeHN4iKuK+/2OaMSFNVlg6/ct8JKQNyOQFX9oIV5roA13hA/siusBhFV3guI4ucNpEFzhvowtcdtEFwtVubzIIpZ2WQQa/V18DVFDZ4e4CFdR2tz1DBb2dbU5QQWtX6yNU0NjR6gAVPGygxR4EE6mTQRcdsqBKB90gCz7poFtkQRmSQfeYy90eP0My6Hqp/2TQ1VL/yaDvmMuL/XPQf5non4POAfbPD8qCjv3zg2YA+38gHwL2vwzY/wAFsP83NMD+NcD+RTD+0KCC8YcmAw5aBBy0BjhoDXDQGuCgtXDQYjhoMRy0DBr4wABfcoP+AiUQOYyqeP9xAAAAAElFTkSuQmCC"
                  class="contact_icon1" />
                <label class="contact_text2">快速响应</label>
              </div>
              <div class="contact_text5">工作日24小时之内客服反馈</div>
              <div style="display: flex; margin-top: 36px">
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAV1BMVEUAAACDlK10gKd1gqh2gKd1gKd1gaZ0gaZ0gad1gKd0gqd2gad4iLR2gqh1gqd1gaZ1gKd5hqh7hqikrq51gKd1gqd4g6h5gqd6hah7hKp0gad2gad0gKaNRviLAAAAHHRSTlMACvVRjvjr5tyuW4APZ3vyyyUWA7dgQDcsG32C5sjW8QAAAXBJREFUSMeVVtmCgyAMDN4HWrXe6/9/5+5gF+wim2aeasiUkCEJ5EHFyVhkaZoVYxIrYqCnMjouiMpJUxiqfRweHm1om2eTH7fIm+ed/9a91oukmnul+rlKipep23z/5fz7rF2v1nXPzk2Wv/5Vas5Ya+9ctclCWr2bmwMoB7rBUJrFN0ZsTF8UQG32uETVRwgnpiBiOOSbzafJj+fvhdD9ZrfFV0P/or74DFZet26/LEoEdWqeHJ8QBhyjxS8dcQQX1ENbCXiCguYTeQgSaIe0EsIKsZSAQAXUkhCQzkRCqH6Mo4Qwo7okhB4FJiEoXHJCpelbgieoNgTo1/MEFxKSO/MEd+gR5coTXFrDagSEi4PJDVwNhXJYeW93+VB7O+/urveEZCnW3RWQRg+oeYItUdNlooHzd02AVB6sPb/NuE5cf97I5K2StlzSjIEldVHx7R6ohAPFjSzFjCx/KO7MUJSNXflglz8d5I8T8fPnG8bGQqP+J541AAAAAElFTkSuQmCC"
                  class="contact_icon1" />
                <label class="contact_text2">快速服务</label>
              </div>
              <div class="contact_text5">专业团队为您服务</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- footer -->
    <footer-section></footer-section>
  </div>
</template>
<script>
import HeaderSection from "@/components/public/head.vue";
import FooterSection from "@/components/public/footer.vue";
export default {
  components: {
    HeaderSection,
    FooterSection,
  },
  props: {},
  data() {
    return {
      articleId: 0,
      articleDetail: {},
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {
    //添加标题和meta标签
    let arr = [
      "首页",
      "产品中心",
      "解决方案",
      "客户案例",
      "新闻动态",
      "人才招聘",
      "关于我们",
      "联系我们",
    ];
    document.title = "联系我们-河北科瑞达仪器科技股份有限公司";
    let m = document.querySelectorAll("meta");
    const meta = document.createElement("meta");
    meta.name = "keywords";
    for (let i = 0; i < m.length; i++) {
      arr.some((item) => {
        if (item == m[i].content) {
          m[i].remove();
        }
      });
    }
    meta.content = "联系我们";

    m[0].after(meta);
    for (let i = 0; i < m.length; i++) {
      if (m[i].content == "河北科瑞达仪器科技股份有限公司") {
        m[i].remove();
      }
    }
  },
  mounted() {},
};
</script>
<style scoped>
#contact-index {
  overflow-x: hidden;
}
/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/
#hero-contact {
  width: 100%;
  height: 45vh;
  background: url("~@/static/img/banner/contact-banner.jpg");
  background-size: cover;
  position: relative;
}
.pdding-l-r-12 {
  padding-left: 12px;
  padding-right: 12px;
}
.margin-l-r-12 {
  margin-left: -12px;
  margin-right: -12px;
}
@media (max-width: 768px) {
  .nap-container {
    width: 100%;
    padding: 0 16px;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .nap-container {
    width: 100%;
    padding: 0 64px;
  }
}

@media (min-width: 991px) and (max-width: 1540px) {
  .nap-container {
    width: 100%;
    padding: 0 130px;
  }
}

@media (min-width: 1541px) {
  .nap-container {
    width: 1280px;
    margin: 0 auto;
  }
}
.contact {
  padding-bottom: 45px;
}

.contact .contact_banner_div {
  height: 505px;
}

.contact .contact_banner_div .contact_banner {
  width: 100%;
  height: 45vh;
  -o-object-fit: cover;
  object-fit: cover;
  display: block;
}

.contact .contact_banner_div .contact_header {
  position: relative;
  margin-top: -300px;
}

.contact .contact_banner_div .contact_banner_text1 {
  font-size: 42px;
  color: #333;
}

.contact .contact_banner_div .contact_banner_text2 {
  font-size: 14px;
  width: 60%;
  line-height: 14px;
  margin-top: 24px;
  margin-bottom: 70px;
  color: #333;
}

.contact .contact_title_div {
  font-size: 24px;
  color: #333;
  padding-left: 10px;
  border-left: 2px solid #004baa;
  height: 28px;
  line-height: 28px;
  margin-top: 40px;
  margin-bottom: 40px;
  overflow: hidden;
}

.contact .contact_text1 {
  font-size: 14px;
  color: #999;
  line-height: 22px;
}

.contact .contact_us_div {
  padding: 24px 40px;
  background-color: #f5f7fa;
  margin-top: 12px;
}

.contact .contact_icon1 {
  width: 24px;
  height: 24px;
}

.contact .contact_text2 {
  font-size: 16px;
  color: #333;
  margin-left: 16px;
  font-weight: 600;
}

.contact .contact_text3 {
  font-size: 20px;
  color: #666;
  margin-top: 20px;
}

.contact .contact_img1 {
  width: 100%;
  height: 180px;
  display: block;
}

.contact .contact_sug_div {
  position: relative;
  margin-top: -180px;
  height: 180px;
  padding: 40px;
}

.contact .contact_text4 {
  font-size: 20px;
  color: #333;
  margin-bottom: 40px;
  font-weight: 600;
}

.contact .contact_text5 {
  font-size: 14px;
  color: #999;
  padding-left: 40px;
  margin-top: 10px;
}

.contact .contact_plat_div {
  padding: 24px 40px 22px;
  margin-bottom: 12px;
  background-image: linear-gradient(100deg, #f2f7fc, #fff 80%);
  border: 1px solid #dcdfe6;
}

.contact .contact_plat_div .contact_plat_text1 {
  position: absolute;
  font-size: 18px;
  color: #333;
  font-weight: 600;
}

.contact .contact_plat_div .contact_plat_text2 {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
  text-align: right;
}

.contact .contact_plat_div .contact_plat_text3 {
  font-size: 14px;
  line-height: 22px;
  color: #999;
  text-align: right;
}

.contact .contact_sur {
  background: #f2f6fc;
  border: 1px solid #dedfe5;
  padding: 20px 0;
}

.contact .contact_sur .contact_sur_bg {
  display: flex;
  position: relative;
  padding-left: 24px;
  padding-top: 10px;
}

.contact .contact_sur .contact_sur_num {
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  margin-right: 30px;
  background: #004baa;
  border-radius: 50%;
  color: #fff;
  text-align: center;
}

.contact .contact_sur .contact_sur_title {
  font-size: 16px;
  color: #323232;
  line-height: 22px;
  margin-bottom: 12px;
  font-weight: 700;
}

.contact .contact_sur .contact_sur_contact {
  font-size: 14px;
  line-height: 24px;
  color: #999;
  font-weight: 400;
}

.contact .contact_sur .contact_sur_line {
  position: absolute;
  right: 0;
  width: 1px;
  height: 470px;
  background: #ddd;
}

.contact .el-button {
  padding: 10px 24px;
  border-radius: 0;
  background: #004baa;
  border-color: #004baa;
}

.contact .el-button:hover {
  background: #005ddd;
  border-color: #005ddd;
}

@media (min-width: 1281px) and (max-width: 1380px) {
  .contact .contact_sur .contact_sur_bg {
    padding-left: 20px;
  }
}

@media (min-width: 1025px) and (max-width: 1280px) {
  .contact .contact_banner_div .contact_banner_text1 {
    font-size: 30px;
  }

  .contact .contact_sur .contact_sur_bg {
    padding-left: 0;
    justify-content: center;
  }

  .contact .contact_sur .contact_sur_num {
    width: 32px;
    height: 32px;
    line-height: 32px;
    margin-right: 10px;
  }

  .contact .contact_sur .contact_sur_title {
    font-size: 15px;
  }

  .contact .contact_sur .contact_sur_contact {
    font-size: 13px;
  }
}

@media (max-width: 1200px) {
  .contact .contact_banner_div,
  .contact .contact_banner_div .contact_banner {
    height: 320px;
  }

  .contact .contact_banner_div .contact_banner_text1 {
    font-size: 30px;
  }

  .contact .contact_banner_div .contact_header {
    margin-top: -220px;
  }
}

@media (max-width: 1024px) {
  .contact .contact_sur .contact_sur_bg {
    height: 380px;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 10px;
    justify-content: left;
  }

  .contact .contact_sur .contact_sur_bg_m {
    height: 380px;
  }

  .contact .contact_sur .contact_sur_num {
    margin-right: 20px;
  }

  .contact .contact_sur .contact_sur_title {
    margin-bottom: 14px;
  }

  .contact .contact_sur .contact_sur_line {
    width: 86%;
    height: 1px;
    right: 6%;
    bottom: 0;
  }
}

@media screen and (min-width: 768px) {
  .contact_banner_m {
    display: none !important;
  }
}

@media (max-width: 767px) {
  .contact .contact_banner_div_m {
    height: 238px;
  }

  .contact .contact_banner_div_m .contact_banner {
    display: none !important;
  }

  .contact .contact_banner_div_m .contact_banner_m {
    height: 238px;
    width: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    display: block;
  }

  .contact .contact_banner_div_m .contact_header_m {
    padding-top: 100px;
  }

  .contact .contact_banner_div_m .contact_banner_text1_m {
    font-size: 20px;
  }

  .contact .contact_banner_div_m .contact_banner_text2_m {
    width: 100%;
  }

  .contact .contact_title_div_m {
    margin-top: 40px;
    margin-bottom: 20px;
    font-size: 20px;
  }

  .contact .contact_us_m {
    padding-bottom: 24px;
  }

  .contact .contact_text4_m {
    font-size: 16px;
  }
}
.contact_sur_content {
  width: 100%;
}
.contact_sur_addr {
  color: #000;
  font-size: 18px;
  margin-bottom: 8px;
}
.contact .contact_sur .contact_sur_contactor {
  color: #777;
  font-size: 14px;
  line-height: 24px;
}
.contact_sur_phonenumber {
  color: #777;
  font-size: 14px;
  line-height: 24px;
}
.contact_sur_div {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin-bottom: 10px;
  align-items: center;
}
</style>
